import * as React from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { Button, ButtonLink } from "./button";
import { Details } from "./details";
import { Cross2Icon } from "@radix-ui/react-icons";
import { twMerge } from "tailwind-merge";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

type PartProps = {
  name: string;
  className?: string;
  portalContainer: HTMLDivElement;
  scaleItems?: boolean;
  isDisabled?: boolean;
};

export function Part({
  name,
  data,
  className,
  scaleItems,
  isDisabled,
}: PartProps) {
  const { part } = useParams();
  const isSelected = name === part;
  const [boundingRect, setBoundingRect] = React.useState<DOMRect | {}>({});

  // const { resetZoom } = useZoomContext();

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  return (
    <Dialog.Root
      open={isSelected}
      onOpenChange={(o) => !o && navigate(`/?${searchParams.toString()}`)}
      modal
    >
      <li className={className}>
        <Dialog.DialogTrigger asChild disabled={isDisabled}>
          <ButtonLink
            elementType={Link}
            to={`/${name}?${searchParams.toString()}`}
            isDisabled={isDisabled}
            onPress={(e) => {
              setBoundingRect(e.target.getBoundingClientRect());
            }}
            className={twMerge(
              "w-full rounded px-5 py-3 shadow-md transition-transform"
            )}
            dangerouslySetStyle={{
              scale: scaleItems ? `${data.scale * 100}%` : undefined,
            }}
          >
            <code>{name}</code>
          </ButtonLink>
        </Dialog.DialogTrigger>

        <Dialog.Portal>
          <Dialog.Overlay
            className="DialogOverlay pointer-events-none fixed inset-0 bg-black/50 drop-shadow-md backdrop-blur-sm duration-100"
            onClick={(e) => e.stopPropagation()}
          />
          <Dialog.Content
            style={{
              "--x": `${boundingRect.x + boundingRect.width / 2}px`,
              "--y": `${boundingRect.y + boundingRect.height / 2}px`,
              "--width": `${boundingRect.width}px`,
            }}
            onClick={(e) => e.stopPropagation()}
            className="DialogContent max-h-[90svh] w-[90vw] max-w-[980px] overflow-auto rounded-lg border border-stone-600/80 bg-stone-900 px-4 py-5 text-stone-100 will-change-transform focus:outline-none md:max-h-[85vh] md:px-6"
          >
            <Details name={name} data={data} />

            <Dialog.Close asChild >
              <Button
                className="absolute top-[10px] right-[10px] inline-flex h-[25px] w-[25px] appearance-none items-center justify-center rounded-full focus:shadow-[0_0_0_2px] focus:outline-none"
                aria-label="Close"
              >
                <Cross2Icon />
              </Button>
            </Dialog.Close>
          </Dialog.Content>
        </Dialog.Portal>
      </li>
    </Dialog.Root>
  );
}
